var map = {
	"./huamantla/Huamantla1.jpg": 24868,
	"./huamantla/Huamantla2.jpg": 40380,
	"./huamantla/Huamantla3.jpg": 5888,
	"./huamantla/Huamantla4.jpg": 53860,
	"./ixtenco/Ixtenco1.jpg": 94712,
	"./ixtenco/Ixtenco2.jpg": 62528,
	"./ixtenco/Ixtenco3.jpg": 84784,
	"./ixtenco/Ixtenco4.jpg": 65815,
	"./tlaxco/Tlaxco1.jpg": 77571,
	"./tlaxco/Tlaxco2.jpg": 73384,
	"./tlaxco/Tlaxco3.jpg": 88416,
	"./tlaxco/Tlaxco4.jpg": 12964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58068;